// src/utils/iconosEquipos.js

const svgAlimentador = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <circle cx="32" cy="32" r="28" fill="#8B5CF6" stroke="#ffffff" stroke-width="4"/>
  <rect x="23" y="14" width="18" height="7" rx="2" fill="#ffffff"/>
  <path d="M23 21 L41 21 L37.5 38 L26.5 38 Z" fill="#ffffff"/>
  <rect x="26" y="38" width="12" height="3" fill="#ffffff"/>
  <rect x="28" y="41" width="8" height="7" rx="1" fill="#ffffff" opacity="0.9"/>
  <circle cx="32" cy="52" r="1.8" fill="#ffffff"/>
</svg>
`;

const svgAireador = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <circle cx="32" cy="32" r="28" fill="#3B82F6" stroke="#ffffff" stroke-width="4"/>
  <circle cx="32" cy="22" r="7" fill="none" stroke="#ffffff" stroke-width="3"/>
  <path d="M32 15 L32 9 M39 22 L45 22 M32 29 L32 35 M25 22 L19 22" 
        stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
  <path d="M13 44 Q22 38, 31 44 T49 44" 
        fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
  <path d="M13 51 Q22 45, 31 51 T49 51" 
        fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
</svg>
`;

/* ✅ Tolva Madre (engranaje + centro) */
const svgEquipo = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <circle cx="32" cy="32" r="28" fill="#10B981" stroke="#ffffff" stroke-width="4"/>
  <circle cx="32" cy="30" r="9" fill="none" stroke="#ffffff" stroke-width="3"/>
  <path d="M32 15 L32 20 M32 40 L32 45 M17 30 L22 30 M42 30 L47 30 
           M21.5 19.5 L25 23 M39 37 L42.5 40.5 
           M21.5 40.5 L25 37 M39 23 L42.5 19.5" 
        stroke="#ffffff" stroke-width="3" stroke-linecap="round"/>
  <circle cx="32" cy="30" r="3" fill="#ffffff"/>
</svg>
`;

export const ICONO_ALIMENTADOR = `data:image/svg+xml;utf8,${encodeURIComponent(svgAlimentador)}`;
export const ICONO_AIREADOR    = `data:image/svg+xml;utf8,${encodeURIComponent(svgAireador)}`;
export const ICONO_EQUIPO      = `data:image/svg+xml;utf8,${encodeURIComponent(svgEquipo)}`;

export const TAMANO_MARKER = 38;

/* Colores por tipo (para chips, headers y botones) */
export const COLORES_TIPO = {
  alimentador: '#8B5CF6',
  aireador:    '#3B82F6',
  equipo:      '#10B981',
};

/* ✅ Nombres visibles — "Tolva Madre" en lugar de "Equipo" */
export const NOMBRES_TIPO = {
  alimentador: 'Alimentador',
  aireador:    'Aireador',
  equipo:      'Tolva Madre',
};

export function iconoDeTipo(tipo) {
  if (tipo === 'alimentador') return ICONO_ALIMENTADOR;
  if (tipo === 'aireador')    return ICONO_AIREADOR;
  return ICONO_EQUIPO;
}

export function colorPorProfundidad(profundidad, min, max) {
  if (profundidad == null || isNaN(profundidad)) return '#94A3B8';
  const rango = max - min;
  const t = rango > 0 ? (profundidad - min) / rango : 0.5;
  const inicio = { r: 186, g: 230, b: 253 };
  const fin    = { r: 12,  g: 74,  b: 110 };
  const r = Math.round(inicio.r + (fin.r - inicio.r) * t);
  const g = Math.round(inicio.g + (fin.g - inicio.g) * t);
  const b = Math.round(inicio.b + (fin.b - inicio.b) * t);
  return `rgb(${r}, ${g}, ${b})`;
}